import {
  request,
  request3,
  request4,
  zujuanrequest,
  request9
} from "../utils/request";
const qusetionfcuntion = {
  //获取一级菜单列表的办法。
  getexamAppOne(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManage/examAppOne",
      data
    });
  },
  //获取二级菜单列表的办法。
  getexamAppTwo(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManage/examAppTwo",
      data
    });
  },
  //获取三级菜单列表的办法。
  getexamAppThree(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManage/examAppThree",
      data
    });
  },
  //合并菜单
  examApp(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManageTopic/examApp",
      data
    });
  },
  //获取章节数据。 ---->智能组卷
  getChapterMenu(data) {
    return request({
      method: "GET",
      url: `/api/paperManage/chapterMenuApi/getChapterMenu/${data}`
    });
  },
   //获取章节数据。 ---->难易度组卷
   getCptData(data) {
    return request({
      method: "POST",
      url: `/api/paperManage_difflevel/cptData/getCptData`,
      data
    });
  },
  // 获取科目章节难易度数据  ---->难易度组卷
  getdifficalArr(data) {
    return request({
      method: "POST",
      url: '/api/paperManage_difflevel/cptData/getdifficalArr',
      data
    });
  },
  // 难易度组卷 --------> 智能添题
  smartAddTest(data) {
    return request({
      method: "POST",
      url: '/api/paperManage_difflevel/editPaper/add/smartAddTest',
      data
    });
  },
  //获取题型数据。
  getappstyle(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/appstyleapi/getappstyle",
      data
    });
  },
  // //验证特殊题型组题是否合理
  checktype(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/appstyleapi/typeNum",
      data
    });
  },
  //添加考生，组管理列表
  getstudentlist(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/groupManage/groupList",
      data
    });
  },
  //添加考生，全部考生
  addstudentlist(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/getStudentList",
      data
    });
  },
  //添加特定科室内的考生。
  getseekAndCreateExam(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/seekAndCreateExam",
      data
    });
  },
  //智能校验第三步
  checkPaper(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/createPaperApi2/checkPaper",
      data
    });
  },
  //智能生成试卷
  setcreatePaper_test(data) {
    // request.interceptors.request.use(config => {
    //   config.headers["Content-Type"] = "multipart/form-data";
    //   return config;
    // });
    return zujuanrequest({
      method: "POST",
      url: "/api/papermanage/createPaperApi2/createPaper_test?paperMode=online",
      data
    });
  },
  //精准生成试卷
  setcreatePaper_actest(data) {
    // request.interceptors.request.use(config => {
    //   config.headers["Content-Type"] = "multipart/form-data";
    //   return config;
    // });
    return zujuanrequest({
      method: "POST",
      url: "/api/papermanage/createPaperApi2_manual/createPaper_test",
      data
    });
  },
  //试卷生成试卷
  setcreatePaper_papertest(data) {
    // request.interceptors.request.use(config => {
    //   config.headers["Content-Type"] = "multipart/form-data";
    //   return config;
    // });
    return zujuanrequest({
      method: "POST",
      url: "/api/overridePaper/createPaper/createPaper_test",
      data
    });
  },
  // 权重生成试卷
  setcreatePaper_weight(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/ProportionPaper/CreatePaper_p/createPaper?paperMode=online",
      data
    });
  },
  // 难易度组卷生成组卷
  createPaper_diflever(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/paperManage_difflevel/paper/createPaper_diflever",
      data
    });
  },
  // 试题查重 
  compareTest(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/papermanage/createPaperApi2/compareTest",
      data
    });
  },
  //根据章节查询试题列表
  getTestByAppENameAndCptID(data) {
    return request({
      method: "POST",
      url: "/api/paperManage/addNewTestApi/getTestByAppENameAndCptID",
      data
    });
  },
  // 根据章节查询试题列表 ---> 难易度
  getCptStyleTest(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/replace/getCptStyleTest",
      data
    });
  },
  //查询分数设置列表 appstyleapi_manual/getAppStyle
  getAppStyle(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/appstyleapi_manual/getAppStyle",
      data
    });
  },
  //导出试卷的接口  第一步get请求远程c++服务器
  getAspx(data) {
    return request3({
      method: "GET",
      url: `/khy.aspx?${data}`
    });
  },
  // 5.12 换了一个导出试卷接口
  getNewAspx(data) {
    return request9({
      method: "GET",
      url: `/export/export?${data}`,
      responseType: "blob",
      data
    });
  },
  //打开公告，调取已经从远程服务器缓存好的数据，里面是有下载的历史的。
  getSysNoticeList(data) {
    return request3({
      method: "POST",
      url: `/api/notice/sysNoticeApi/sysNoticeList`,
      data
    });
  },
  //点击公告里面的内容，点击单个，返回单个内容里面的SourceID
  getClickNoticeCount(data) {
    return request3({
      method: "POST",
      url: `/api/notice/sysNoticeApi/clickNoticeCount`,
      data
    });
  },
  createPaper_test(data) {
    return zujuanrequest({
      method: "POST",
      url: `/api/papermanage/createpaperapi2/createPaper_test`,
      data
    });
  },
  //试卷统一替换试卷。
  ManualTest(data) {
    return request({
      method: "POST",
      url: `/api/overridePaper/updatePaper/ManualTest`,
      data
    });
  },
  //试卷统一替换保存
  SaveManualTest(data) {
    return request({
      method: "POST",
      url: `/api/overridePaper/updatePaper/SaveManualTest`,
      data
    });
  },
  // 题库查询
  searchTestByAppENameAndKeyWord(data) {
    return request({
      method: "POST",
      url: "/api/paperManage/addNewTestApi/searchTestByAppENameAndKeyWord",
      data
    });
  },
  // 2024/3/11 新增获取oss临时密钥
  getUploadSTSAuth(data) {
    return request({
      method: "POST",
      url: "/api/aliyun/auth/getUploadSTSAuth",
      data
    });
  }
};
export default qusetionfcuntion;
